import React, { useEffect, useState } from "react";

const API_BASE = "https://creaive.ai";

const PopupModal = () => {
  const [imageUrl, setImageUrl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/popup`);
        const data = await res.json();
        if (data.enabled && data.imageUrl) {
          setImageUrl(`${API_BASE}${data.imageUrl}`);
          setOpen(true);
        }
      } catch (err) {
        console.error("Failed to fetch popup:", err);
      }
    };

    fetchPopup();
  }, []);

  if (!open || !imageUrl) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fadeIn"
      onClick={() => setOpen(false)}
    >
      <div
        className="relative max-w-3xl w-[92%] md:w-[80%] lg:w-[60%] animate-scaleIn"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={() => setOpen(false)}
          className="absolute -top-3 -right-3 z-10 bg-white text-gray-700 hover:text-red-500 rounded-full w-8 h-8 flex items-center justify-center shadow-lg transition-colors duration-200 text-lg font-bold"
          aria-label="Close popup"
        >
          ✕
        </button>

        {/* Image */}
        <img
          src={imageUrl}
          alt="Popup"
          className="w-full h-auto rounded-xl shadow-2xl"
        />
      </div>
    </div>
  );
};

export default PopupModal;
